module.exports = __webpack_public_path__ + "static/media/Phonepe.1620d423.png";